const modal = require(MODULES_PATH + '/modal');
import Player from '@vimeo/player';
import gsap from 'gsap';
import { debounce } from './0_utils';

if (document.querySelector('#modal-form')) {
    let modalForm = new modal({
        modalId: 'modal-form',
        openButtonClass: 'open-modal',
        closeButtonClass: 'close-modal',
        backdrop: {
            color: '#000',
            opacity: 0.8,
            effect: true,
            blur: 5,
        },
    });
}

let videoModalElements = document.querySelectorAll('.video-modal');
if (videoModalElements) {
    videoModalElements.forEach((videoModalElement) => {
        const modalId = videoModalElement.getAttribute('data-modal-id');
        const modalIdFormatted = modalId.replace(/-/g, '');
        const closeModalBtn = videoModalElement.querySelector('.js-modal-close');
        const playPauseBtn = videoModalElement.querySelector('.js-video-play-pause');
        const muteUnmuteBtn = videoModalElement.querySelector('.js-video-mute-unmute');
        const videoElement = videoModalElement.querySelector('iframe') ? videoModalElement.querySelector('iframe') : videoModalElement.querySelector('video');
        const mobileVideoElement = videoModalElement.querySelector('.mobile-video-modal iframe') ? videoModalElement.querySelector('.mobile-video-modal iframe') : videoModalElement.querySelector('.mobile-video-modal video');

        let videoModal = new modal({
            modalId: 'video-modal-' + modalId,
            scrollTracker: true,
            scrollAdjust: false,
            center: true,
            closeOnWrapperClick: false,
            backdrop: {
                effect: false,
            },
        });

        const playButton = document.querySelector('.js-play-video-' + modalId);
        if (playButton) {
            playButton.addEventListener('click', function () {
                videoModal.show();
            });
        }

        if (closeModalBtn) {
            closeModalBtn.addEventListener('click', function () {
                let callback = function () {
                    videoModal.hide();
                };

                closeModal(videoModalElement, callback);
            });
        }

        if (playPauseBtn) {
            playPauseBtn.addEventListener('click', function () {
                playPauseBtn.classList.toggle('paused');
                const video = window.innerWidth < 1024 && mobileVideoElement ? mobileVideoElement : videoElement;
                if (video && video.tagName === 'IFRAME') {
                    const player = new Player(video);
                    player.getPaused().then((paused) => {
                        if (paused) {
                            player.play().catch((error) => {});
                        } else {
                            player.pause().catch((error) => {});
                        }
                    });
                } else if (video && video.tagName === 'VIDEO') {
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                }
            });
        }

        if (muteUnmuteBtn) {
            let playerInstance = null; // Store player instance globally

            muteUnmuteBtn.addEventListener('click', function () {
                muteUnmuteBtn.classList.toggle('muted');
                const video = window.innerWidth < 1024 && mobileVideoElement ? mobileVideoElement : videoElement;
                if (video && video.tagName === 'IFRAME') {
                    // Initialize player only once
                    if (!playerInstance) {
                        playerInstance = new Player(video);
                    }

                    // Get current mute state and toggle it
                    playerInstance
                        .getMuted()
                        .then(function (isMuted) {
                            playerInstance.setMuted(!isMuted).catch(function (error) {
                                console.error('Mute toggle failed:', error);
                            });
                        })
                        .catch(function (error) {
                            console.error('Failed to get mute state:', error);
                        });
                } else if (video && video.tagName === 'VIDEO') {
                    // Regular video element handling
                    video.muted = !video.muted;
                }
            });

            // Initialize player when modal opens
            document.addEventListener('videomodal' + modalIdFormatted + 'modalopened', function () {
                const video = window.innerWidth < 1024 && mobileVideoElement ? mobileVideoElement : videoElement;
                if (video && video.tagName === 'IFRAME' && !playerInstance) {
                    playerInstance = new Player(video);
                }
            });
        }

        document.addEventListener('videomodal' + modalIdFormatted + 'modalopened', function () {
            const video = window.innerWidth < 1024 && mobileVideoElement ? mobileVideoElement : videoElement;

            // initModalVideo(videoElement);
            if (video && video.tagName === 'IFRAME') {
                const player = new Player(video);
                player.ready().then(() => {
                    setTimeout(function () {
                        player.setMuted(false);
                        player.setVolume(1);
                        player.play().catch((error) => {
                            console.log(error);
                        });
                    }, 500);
                });
            } else if (video && video.tagName === 'VIDEO') {
                video.volume = 1;
                video.play();
            }
        });

        window.addEventListener(
            'resize',
            debounce(function () {
                // initModalVideo(videoElement);
            }, 100),
        );
    });

    function initModalVideo(videoElement) {
        if (window.innerWidth < 1024) {
            return;
        }
        let parent = videoElement.closest('.modal__video');
        let ratio = parent.getAttribute('data-ratio') ? parent.getAttribute('data-ratio') : '16:9',
            width = parseFloat(ratio.split(':')[0]),
            height = parseFloat(ratio.split(':')[1]);

        if (parent.clientWidth / width > parent.clientHeight / height) {
            videoElement.style.width = '100%';
            videoElement.style.height = 'auto';
        } else {
            videoElement.style.width = `100%`;
            videoElement.style.height = '100%';
        }
    }
}

document.addEventListener('modalopened', function () {
    let modalElement = document.querySelector('.video-modal.modal.active');
    if (modalElement) {
        openModal(modalElement);
    }
});

document.addEventListener('closemodal', function () {
    let modalElement = document.querySelector('.video-modal.modal.active');
    if (modalElement) {
        modalElement.classList.remove('active');
        const videoElement = modalElement.querySelector('iframe') ? modalElement.querySelector('iframe') : modalElement.querySelector('video');
        const mobileVideoElement = modalElement.querySelector('.mobile-video-modal iframe') ? modalElement.querySelector('.mobile-video-modal iframe') : modalElement.querySelector('.mobile-video-modal video');

        const video = window.innerWidth < 1024 && mobileVideoElement ? mobileVideoElement : videoElement;

        if (video && video.tagName === 'IFRAME') {
            const player = new Player(video);
            player.pause().catch((error) => {});
        } else if (video && video.tagName === 'VIDEO') {
            video.pause();
        }
    }
});

function openModal(modalElement) {
    gsap.fromTo(modalElement, { opacity: 1, scale: 0.5, yPercent: 100, borderRadius: 80 }, { scale: 1, yPercent: 0, duration: 0.9, delay: 0.2, borderRadius: 0 });
}

function closeModal(modalElement, callback = false) {
    if (!callback) {
        callback = function () {};
    }

    gsap.to(modalElement, {
        opacity: 0,
        yPercent: -5,
        duration: 1,
        onComplete: callback,
    });
}

if (document.querySelector('#ajax-modal')) {
    let ajaxModal = new modal({
        modalId: 'ajax-modal',

        closeButtonClass: 'close-modal',
        backdrop: {
            color: '#000',
            opacity: 0.8,
            effect: true,
            blur: 5,
        },
    });

    function initAjaxModalButton(button) {
        if (button.dataset.listenerAdded) return;
        button.addEventListener('click', function () {
            const postId = this.getAttribute('data-post-id');
            const modalContent = document.querySelector('#ajax-modal .ajax-modal-content');

            fetch(ajax.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'load_portfolio_modal',
                    nonce: ajax.nonce,
                    post_id: postId,
                }),
            })
                .then((response) => response.text())
                .then((data) => {
                    modalContent.innerHTML = data;
                    ajaxModal.show();
                })
                .catch((error) => console.error('AJAX Error:', error));
        });
        button.dataset.listenerAdded = true;
    }

    document.querySelectorAll('.portfolio-company-modal-js').forEach(initAjaxModalButton);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return;
                if (node.matches('.portfolio-company-modal-js')) {
                    initAjaxModalButton(node);
                }
                node.querySelectorAll?.('.portfolio-company-modal-js').forEach(initAjaxModalButton);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
}
